import { createDirtyChecker, compareByPaths } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToCloudAccountPartial } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToCloudAccountPartial, compareByPaths({
    description: { path: "description" },
    tags: { path: "tags" },
  }));
}
